import { useOutletContext } from "react-router-dom";
import Home from "./Home";
import Details from "./Details";
import Availability from "./Availability";
import Promotions from "./Promotions";
import Informations from "./Informations";
import RoomTypesAndPriceLevels from "./RoomTypesAndPriceLevels";
import PricingOptionsAndAvailability from "./PricingOptionsAndAvailability";
import Restrictions from "./Restrictions";
import CancellationPolicy from "./CancellationPolicy";
import OccupancyAndFees from "./OccupancyAndFees";
import RateAutomatic from "./RateAutomatic";
import Album from "./Album";
import AvailabilityUpdatesByBblock from "./AvailabilityUpdatesByBblock";
function RouteMap(props) {
  const { profile, theme } = useOutletContext();
  const composite = {
    home: <Home theme={theme} profile={profile} />,
    detail: <Details theme={theme} profile={profile} />,
    availability: <Availability theme={theme} profile={profile} />,
    promotions: <Promotions theme={theme} profile={profile} />,
    informations: <Informations theme={theme} profile={profile} />,
    roomTypesAndPriceLevels: (
      <RoomTypesAndPriceLevels theme={theme} profile={profile} />
    ),
    pricingOptionsAndAvailability: (
      <PricingOptionsAndAvailability theme={theme} profile={profile} />
    ),
    restrictions: <Restrictions theme={theme} profile={profile} />,
    cancellationPolicy: <CancellationPolicy theme={theme} profile={profile} />,
    accupancyAndFees: <OccupancyAndFees theme={theme} profile={profile} />,
    // AvailabilityUpdatesByBblock: <AvailabilityUpdatesByBblock theme={theme} profile={profile} />,
    rateAutomatic: <RateAutomatic theme={theme} profile={profile} />,
    album: <Album theme={theme} profile={profile} />,
  };
  return <>{composite[props.component]}</>;
}
export default RouteMap;
